<template>
	<span
		v-if="!hasExpired"
		class="countdown-container"
	>
		<span
			v-if="days > 0"
			class="countdown-days"
			>{{ days }} {{ days === 1 ? 'day' : 'days' }}</span
		>
		<span class="countdown-time">{{ formattedTime }}</span>
	</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		targetEpoch: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			currentTime: Date.now(),
			intervalId: null as number | null,
		};
	},
	computed: {
		hasExpired(): boolean {
			return this.currentTime >= this.targetEpoch;
		},
		timeRemaining(): number {
			return Math.max(0, this.targetEpoch - this.currentTime);
		},
		days(): number {
			return Math.floor(this.timeRemaining / (1000 * 60 * 60 * 24));
		},
		hours(): number {
			return Math.floor((this.timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		},
		minutes(): number {
			return Math.floor((this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
		},
		seconds(): number {
			return Math.floor((this.timeRemaining % (1000 * 60)) / 1000);
		},
		formattedTime(): string {
			const h = String(this.hours).padStart(2, '0');
			const m = String(this.minutes).padStart(2, '0');
			const s = String(this.seconds).padStart(2, '0');
			return `${h}:${m}:${s}`;
		},
	},
	mounted() {
		this.startCountdown();
	},
	beforeUnmount() {
		this.stopCountdown();
	},
	methods: {
		startCountdown() {
			this.intervalId = window.setInterval(() => {
				this.currentTime = Date.now();
			}, 1000);
		},
		stopCountdown() {
			if (this.intervalId !== null) {
				clearInterval(this.intervalId);
				this.intervalId = null;
			}
		},
	},
});
</script>

<style scoped lang="scss">
.countdown-container {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-weight: 600;
	font-size: 1.2em;
}

.countdown-days {
	margin-right: 4px;
}

.countdown-time {
	font-variant-numeric: tabular-nums;
}
</style>
